$(function() {

    var clientIp;
	$.getJSON("https://api.ipify.org/?format=json", function(e) {
		clientIp =  e.ip;
	});

	$(".calc-submit").on('click', function(){

        var form = new FormData();
      
        form.append("length", $('#length').val());
        form.append("girth", $('#girth').val());
        form.append("unit", $('#unitHold').text());
        form.append("clientIp", clientIp);

        var settings = {
          "url": "https://hub.bathmatedirect.com/calculator/index.php",
          "method": "POST",
          "timeout": 0,
          "processData": false,
          "mimeType": "multipart/form-data",
          "contentType": false,
          "data": form
      };

      if($('#length').val().length > 0 && $('#girth').val().length > 0){
        $.ajax(settings).done(function (response) {
            console.log('response',response);
        });
      }
	});
});